<template>
  <div style="text-align: left;">

    <div>
      <h3>Supervisor</h3>
      <el-row>
        <el-col :span="8">
          <img src="../../assets/sebastian.jpg" style="width: 90%;height: auto;margin-top: 12px;" />
        </el-col>
        <el-col :span="12">
          <p><strong>Sebastian Wachsmann-Hogiu</strong></p>
          <p> </p>
          <p>Professor</p>
          <p>BE and BBME</p>
          <a href="sebastian.wachsmannhogiu@mcgill.ca">sebastian.wachsmannhogiu@mcgill.ca</a>
        </el-col>
      </el-row>
    </div>

  

    <div>
      <h3>Current Members:</h3>
      
      <el-row>
        <el-col :span="24" v-for="item in data">
          <el-row>
            <el-col :span="8" style="padding: 6px " >
              <img :src="item.avatar" style="width: 80%;height: auto;"/>
            </el-col>
            <el-col :span="10" style="text-align: justify;"> 
              <p>
                <strong>{{item.name}}</strong>
              </p>
              <p>{{item.position}}</p>              
              <a :href="'mailto:' + item.email">{{item.email}}</a>
              <p>
               {{item.something}}
              </p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

  <div>
      <h3>Past Members:</h3>
      <el-row>
        <el-col :span="6" v-for="item in data">
          <el-row>
            <el-col :span="14" style="padding: 6px;" >
              <img :src="item.avatar1" style="width: 100%;height: auto;"/>
            </el-col>
            <el-col :span="18">
              <p>
                <strong>{{item.name1}}</strong>
              </p>
              <p>{{item.position1}}</p>
              <a :href="'mailto:' + item.email1">{{item.email1}}</a>
              <p>{{item.something1}}</p>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>




  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: [
            
       {
          avatar: require('../../assets/juan.jpg'),
          name: 'Juanjuan Liu',
          position: 'Postdoc, BBME',
          something: 'Juanjuan joined the lab in September 2017. She is working on development of substrates to build biosensing systems used for low resources environments.',
          email: 'juanjuan.liu@mail.mcgill.ca',
          
          avatar1: require('../../assets/sorina.jpg'),
          name1: 'Sorina Suarasan',
          something1: '',
          position1: 'Postdoc, BBME',
          email1: '', 

        }, {
          avatar: require('../../assets/Mira.jpg'),
          name: 'Meruyert Imanbekova',
          something: 'Meruyert joined the lab in January 2019. She is working on the identification and characterization of extracellular vesicles associated biomarkers of neurodegenerative diseases.',
          position: 'Ph.D. Candidate, BBME',
          email: 'meruyert.imanbekova@mail.mcgill.ca',

          avatar1: require('../../assets/team.jpg'),
          name1: 'Lena Kozarov',
          something1: '',
          position1: 'Undergraduate student, BE',                
          email1: '',
        },  {
          avatar:require('../../assets/Reza.jpg'),
          name: 'Reza Abbasi',
          something: 'Reza joined the lab in September 2019. He is working on integrated optical systems for the characterization of sub-micrometer vesicles.',
          position: 'Ph.D. Candidate, BBME',
          email: 'reza.abbasi@mail.mcgill.ca',

          avatar1: require('../../assets/Sara.jpg'),
          name1: 'Sara Kheireddine',
          position1: 'Ph.D., BBME',
          something1: '',
          email1: '',
        },
        {
          avatar:require('../../assets/Adam.jpeg'),
          name: 'Adam Melnyk',
          something: 'Adam joined the lab in September 2020. He is working on integrated optical systems for biosensing.',
          position: 'Master\'\s Student, BBME',
          email: 'adam.melnyk@mail.mcgill.ca',

          avatar1: require('../../assets/team.jpg'),
          name1: 'Maya Kenton',
          something1: '',
          position1: 'Undergraduate student, BE',
          email1: '',
        }, 
        {
          avatar:require('../../assets/Mohul.jpg'),
          name: 'Mohul Sharma',
          something: '',
          position: 'Undergraduate Student, BE',
          email: 'mohul.sharma@mail.mcgill.ca',

          avatar1: require('../../assets/Houda.png'),
          name1: 'Houda Shafique',
          something1: '',
          position1: 'Undergraduate student, BE',
          email1: '',
        }, {
          avatar:require('../../assets/Marion.jpg'),
          name: 'Marion Vandewynckele-Bossut',
          something: '',
          position: 'Undergraduate Student, BE',
          email: 'marion.vandewynckele-bossut@mail.mcgill.ca',

          avatar1: require('../../assets/team.jpg'),
          name1:'Reem kettaneh',
          position1:'Master\'\s Student',
          email1: '',
        },{
          avatar1: require('../../assets/team.jpg'),
          name1: 'Mehmet Kahraman',
          position1: '',
          something1: '',
          email1: '',
        },{
          avatar1: require('../../assets/team.jpg'),
          name1: 'Aysun Korkmaz',
          position1: 'Ph.D.',
          something1: '',
          email1: '',
        },
      ]


      };
    },
    methods: {}



  };
</script>




<style scoped>
</style>



<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/content/Team.vue